import '@angular/compiler'; // ensure JIT compiler present
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideZonelessChangeDetection, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AbstractSecurityStorage, authInterceptor, provideAuth } from 'angular-auth-oidc-client';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { authConfig } from './app/auth/auth.config';
import { StorageService } from './app/auth/auth-storage.service';
import { unauthorizedInterceptor } from './app/auth/unauthorized.interceptor';
import { TranslocoHttpLoader } from './app/services/transloco-loader';
import { provideTransloco } from '@jsverse/transloco';

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor(), unauthorizedInterceptor])),
    provideAuth(authConfig),
    { provide: AbstractSecurityStorage, useClass: StorageService },
    provideTransloco({
      config: {
        availableLangs: ['en', 'de'],
        defaultLang: 'en',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
});
